import { render, staticRenderFns } from "./TicTacToe.vue?vue&type=template&id=15db2b92&scoped=true&"
import script from "./TicTacToe.vue?vue&type=script&lang=js&"
export * from "./TicTacToe.vue?vue&type=script&lang=js&"
import style0 from "./TicTacToe.vue?vue&type=style&index=0&id=15db2b92&prod&lang=css&"
import style1 from "./TicTacToe.vue?vue&type=style&index=1&id=15db2b92&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15db2b92",
  null
  
)

export default component.exports